<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-card-title class="text-subtitle-1">
            Rol de limpieza
            <v-spacer></v-spacer>
            <v-btn
              class="mr-2"
              color="indigo"
              small
              dark
              tile
              :disabled="!ciclo"
              @click="abrirResumen"
            >
              <v-icon small left>mdi-account-group</v-icon>
              Resumen
            </v-btn>
            <v-btn
              class="mr-2"
              color="teal"
              small
              dark
              tile
              :disabled="!ciclo"
              @click="abrirTotal"
            >
              <v-icon small left>mdi-format-list-bulleted</v-icon>
              Total
            </v-btn>
            <v-btn
              v-if="puedeEditarTarifas"
              class="mr-2"
              color="blue"
              small
              dark
              tile
              @click="abrirPagos"
            >
              <v-icon small left>mdi-cash</v-icon>
              Pagos
            </v-btn>
            <v-btn
              class="mr-2"
              color="green"
              small
              dark
              tile
              :disabled="!filasFiltradas.length"
              @click="exportarExcel"
            >
              <v-icon small left>mdi-microsoft-excel</v-icon>
              Excel
            </v-btn>
            <v-btn color="orange" small dark tile @click="consultar">
              <v-icon small>mdi-refresh</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  single-line
                  hide-details
                  return-object
                  item-text="ciclo"
                  item-value="id_ciclo"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" sm="6" lg="4" xl="3">
                <v-radio-group v-model="escuela" row hide-details>
                  <v-radio label="INBI" :value="1"></v-radio>
                  <v-radio label="FAST" :value="2"></v-radio>
                  <v-radio label="AMBAS" :value="3"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>

            <v-row justify="space-between">
              <v-col cols="12" md="6" lg="4">
                <v-autocomplete
                  :items="semanas"
                  v-model="semana"
                  label="SEMANA"
                  filled
                  hide-details
                  item-text="texto"
                  item-value="value"
                  :disabled="!ciclo"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" md="6" lg="6">
                <v-text-field
                  v-model="search"
                  label="Buscar sucursal o intendente"
                  dense
                  filled
                  hide-details
                  single-line
                  clearable
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <h3>SUCURSALES: {{ filasFiltradas.length }}</h3>
                <h3>DÍAS ASIGNADOS: {{ totales.asignados }} / {{ totales.dias }}</h3>
                <h3>SIN HUELLA: {{ totales.sinChecada }}</h3>
              </v-col>
              <v-col cols="12" md="6">
                <h3>INTENDENTES ACTIVOS: {{ trabajadores.length }}</h3>
                <div class="caption grey--text">
                  En amarillo: el día ya pasó y el intendente no checó en ninguna sucursal.
                </div>
              </v-col>
            </v-row>

            <v-data-table
              :headers="headers"
              :items="filasFiltradas"
              class="elevation-0"
              height="500"
              dense
              fixed-header
              item-key="id_plantel"
              :loading="cargar"
              :items-per-page="10"
              :footer-props="{ 'items-per-page-options': [10, 25, -1] }"
            >
              <template v-slot:item.escuela="{ item }">
                <v-chip v-if="item.escuela == 1" small rounded color="blue lighten-2" dark>INBI</v-chip>
                <v-chip v-else-if="item.escuela == 2" small rounded color="blue darken-2" dark>FAST</v-chip>
                <v-chip v-else small rounded color="grey" dark>CORPO</v-chip>
              </template>

              <template v-slot:item.plantel="{ item }">
                <span class="subrayado">{{ item.plantel }}</span>
              </template>

              <template v-for="dia in diasSemana" v-slot:[dia.slot]="{ item }">
                <div v-if="item[dia.key]" :key="dia.key" class="py-2">
                  <span
                    type="button"
                    class="text-caption"
                    :class="{ 'celda-sin-checada': sinChecada(item[dia.key], dia.fecha) }"
                    @click="abrirAsignar(item, dia)"
                  >
                    <v-icon :color="colorAsistencia(item[dia.key].asistencia)">mdi-circle-medium</v-icon>
                    {{ item[dia.key].nombre_completo }}
                  </span>

                  <div v-if="item[dia.key].checada" class="text-caption">
                    {{ dia.fecha }} {{ item[dia.key].checada.primera }}
                    <span v-if="item[dia.key].checada.ultima !== item[dia.key].checada.primera">
                      / {{ item[dia.key].checada.ultima }}
                    </span>
                  </div>
                  <div
                    v-for="(otra, i) in item[dia.key].checadas_otra_sucursal"
                    :key="i"
                    class="text-caption grey--text"
                  >
                    Checó en {{ otra.plantel }} {{ otra.primera }}
                  </div>
                  <div v-if="item[dia.key].huella && item[dia.key].huella.manual" class="text-caption">
                    Checada manual {{ item[dia.key].huella.primera }}
                    <span v-if="item[dia.key].huella.ultima !== item[dia.key].huella.primera">
                      / {{ item[dia.key].huella.ultima }}
                    </span>
                  </div>

                  <span type="button" @click="abrirAsistencia(item, dia)">
                    <v-chip v-if="item[dia.key].asistencia == 1" color="green" dark small class="mt-1">Asistió</v-chip>
                    <v-tooltip v-else-if="item[dia.key].asistencia == 2" bottom :disabled="!item[dia.key].comentario_asistencia">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip v-bind="attrs" v-on="on" color="red" dark small class="mt-1">No asistió</v-chip>
                      </template>
                      <span>{{ item[dia.key].comentario_asistencia }}</span>
                    </v-tooltip>
                    <v-chip v-else color="pink" dark small class="mt-1">Asistencia</v-chip>
                  </span>
                </div>

                <span
                  v-else
                  :key="dia.key"
                  type="button"
                  class="text-caption"
                  @click="abrirAsignar(item, dia)"
                >
                  <v-icon color="grey">mdi-circle-medium</v-icon>
                  SIN ASIGNAR
                </span>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Asignar intendente -->
    <v-dialog v-model="dialogAsignar.estatus" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">Asignar intendente</v-card-title>
        <v-card-text>
          <div><b>Sucursal:</b> {{ dialogAsignar.plantel }}</div>
          <div class="mb-3"><b>Día:</b> {{ dialogAsignar.diaTexto }}</div>
          <v-autocomplete
            filled
            dense
            clearable
            hide-details
            v-model="dialogAsignar.id_trabajador"
            :items="trabajadoresDialog"
            item-text="texto"
            item-value="id_trabajador"
            label="Intendente"
          ></v-autocomplete>
          <div v-if="!trabajadores.length" class="caption red--text mt-2">
            No hay trabajadores activos con puesto de intendente (89).
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="dialogAsignar.asignacion"
            color="red"
            small
            dark
            tile
            @click="eliminarAsignacion"
          >
            Quitar
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="black" small text tile @click="dialogAsignar.estatus = false">Cancelar</v-btn>
          <v-btn color="green" small dark tile @click="guardarAsignacion(false)">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Confirmar varias sucursales el mismo día -->
    <v-dialog v-model="dialogConfirmar.estatus" max-width="520" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          <v-icon color="orange" class="mr-2">mdi-alert</v-icon>
          Esta intendente ya tiene asignación ese día
        </v-card-title>
        <v-card-text>
          <div>
            <b>{{ dialogConfirmar.nombre }}</b> ya está asignada el <b>{{ dialogConfirmar.diaTexto }}</b> en:
          </div>
          <ul class="my-2">
            <li v-for="otra in dialogConfirmar.otras" :key="otra.id">
              <b>{{ otra.plantel }}</b>
              <span v-if="otra.checo" class="grey--text"> (checó a las {{ otra.checo }})</span>
            </li>
          </ul>
          <div>¿Confirmas que ese mismo día también irá a <b>{{ dialogAsignar.plantel }}</b>?</div>
          <div class="caption grey--text mt-2">Cada sucursal se paga solo si hay una huella para ella.</div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" small text tile @click="dialogConfirmar.estatus = false">Cancelar</v-btn>
          <v-btn color="orange" small dark tile @click="confirmarAsignacion">Sí, asignar también</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Asistencia -->
    <v-dialog v-model="dialogAsistencia.estatus" max-width="500" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">Asistencia</v-card-title>
        <v-card-text>
          <div><b>Intendente:</b> {{ dialogAsistencia.nombre }}</div>
          <div><b>Sucursal:</b> {{ dialogAsistencia.plantel }}</div>
          <div class="mb-2"><b>Día:</b> {{ dialogAsistencia.diaTexto }}</div>
          <v-radio-group v-model="dialogAsistencia.asistencia" row hide-details class="mt-0">
            <v-radio label="Asistió" :value="1" color="green"></v-radio>
            <v-radio label="No asistió" :value="2" color="red"></v-radio>
            <v-radio label="Pendiente" :value="0"></v-radio>
          </v-radio-group>
          <v-textarea
            v-model="dialogAsistencia.comentario"
            class="mt-3"
            label="Comentario"
            filled
            dense
            rows="2"
            hide-details
            auto-grow
          ></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="black" small text tile @click="dialogAsistencia.estatus = false">Cancelar</v-btn>
          <v-btn color="green" small dark tile @click="guardarAsistencia">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Resumen por intendente -->
    <v-dialog v-model="dialogResumen.estatus" :max-width="dialogResumen.completo ? 1400 : 1200" scrollable>
      <v-card>
        <v-card-title class="text-subtitle-1">
          {{ dialogResumen.completo ? 'Total por intendente' : 'Resumen por intendente' }}
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            color="green"
            small
            dark
            tile
            :disabled="!resumenFilas.length"
            @click="exportarResumen"
          >
            <v-icon small left>mdi-microsoft-excel</v-icon>
            Excel
          </v-btn>
          <v-btn color="red" small dark tile @click="dialogResumen.estatus = false">
            <v-icon small left>mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row align="center" dense>
            <v-col cols="12" md="6">
              <v-radio-group v-model="dialogResumen.modo" row hide-details class="mt-0">
                <v-radio label="Semana seleccionada" value="semana"></v-radio>
                <v-radio label="Ciclo completo" value="ciclo"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="6" class="text-right">
              <div class="font-weight-bold">{{ rangoResumen ? rangoResumen.texto : '' }}</div>
              <div class="caption grey--text">Aplica el filtro de escuela y el buscador de la vista.</div>
            </v-col>
          </v-row>

          <v-row class="mt-2 mb-4" dense>
            <v-col cols="12" md="5">
              <v-autocomplete
                v-model="dialogResumen.id_trabajador"
                :items="resumenIntendentes"
                item-text="nombre"
                item-value="id_trabajador"
                label="Filtrar por intendente"
                prepend-inner-icon="mdi-account-search"
                filled
                dense
                hide-details
                clearable
              ></v-autocomplete>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersResumen"
            :items="resumenFilasTabla"
            class="elevation-0"
            dense
            item-key="key"
            :fixed-header="!dialogResumen.completo"
            :height="dialogResumen.completo ? undefined : 420"
            :items-per-page="dialogResumen.completo ? -1 : 10"
            :hide-default-footer="dialogResumen.completo"
            :item-class="claseFilaResumen"
            no-data-text="Sin asignaciones en el periodo"
          >
            <template v-slot:item.escuela="{ item }">
              <template v-if="item.tipo === 'detalle'">
                <v-chip v-if="item.escuela == 1" small rounded color="blue lighten-2" dark>INBI</v-chip>
                <v-chip v-else-if="item.escuela == 2" small rounded color="blue darken-2" dark>FAST</v-chip>
                <v-chip v-else small rounded color="grey" dark>CORPO</v-chip>
              </template>
            </template>
            <template v-slot:item.sinChecada="{ item }">
              <span :class="{ 'red--text': item.sinChecada }">{{ item.sinChecada }}</span>
            </template>
            <template v-slot:item.total="{ item }">
              {{ formatoMoneda(item.total) }}
            </template>
            <template v-slot:body.append>
              <tr v-if="resumenTotalGeneral" class="fila-subtotal font-weight-bold">
                <td>{{ resumenTotalGeneral.intendente }}</td>
                <td></td>
                <td></td>
                <td class="text-center">{{ resumenTotalGeneral.lvAsignados }}</td>
                <td class="text-center">{{ resumenTotalGeneral.lvHuella }}</td>
                <td class="text-center">{{ resumenTotalGeneral.sabAsignados }}</td>
                <td class="text-center">{{ resumenTotalGeneral.sabHuella }}</td>
                <td class="text-center" :class="{ 'red--text': resumenTotalGeneral.sinChecada }">{{ resumenTotalGeneral.sinChecada }}</td>
                <td class="text-right">{{ formatoMoneda(resumenTotalGeneral.total) }}</td>
              </tr>
            </template>
          </v-data-table>
          <div class="caption grey--text mt-2">
            Total a pagar: solo los días con huella, con la tarifa vigente de la sucursal donde checó en cada fecha.
            "Sin checada": días asignados que ya pasaron y no tienen huella.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Pagos por sucursal -->
    <v-dialog v-model="dialogPagos.estatus" max-width="900" persistent>
      <v-card>
        <v-card-title class="text-subtitle-1">
          Pagos por sucursal
          <v-spacer></v-spacer>
          <v-btn
            class="mr-2"
            color="green"
            small
            tile
            :dark="pagosModificados.length > 0"
            :disabled="!pagosModificados.length"
            @click="guardarPagos"
          >
            <v-icon small left>mdi-content-save</v-icon>
            Guardar ({{ pagosModificados.length }})
          </v-btn>
          <v-btn color="red" small dark tile @click="dialogPagos.estatus = false">
            <v-icon small left>mdi-close</v-icon>
            Cerrar
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-row align="center">
            <v-col cols="12" md="4">
              <v-radio-group v-model="dialogPagos.escuela" row hide-details class="mt-0">
                <v-radio label="INBI" :value="1"></v-radio>
                <v-radio label="FAST" :value="2"></v-radio>
                <v-radio label="AMBAS" :value="3"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="dialogPagos.vigente_desde"
                type="date"
                label="Vigente desde"
                filled
                dense
                hide-details
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-text-field
                v-model="dialogPagos.search"
                label="Buscar sucursal"
                filled
                dense
                hide-details
                single-line
                clearable
              ></v-text-field>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headersPagos"
            :items="pagosFiltrados"
            class="elevation-0 mt-2"
            dense
            fixed-header
            height="400"
            item-key="id_plantel"
            :items-per-page="-1"
            hide-default-footer
          >
            <template v-slot:item.escuela="{ item }">
              <v-chip v-if="item.escuela == 1" small rounded color="blue lighten-2" dark>INBI</v-chip>
              <v-chip v-else-if="item.escuela == 2" small rounded color="blue darken-2" dark>FAST</v-chip>
              <v-chip v-else small rounded color="grey" dark>CORPO</v-chip>
            </template>

            <template v-slot:item.pago_entre_semana="{ item }">
              <v-text-field
                v-model="item.pago_entre_semana"
                type="number"
                min="0"
                prefix="$"
                dense
                hide-details
                single-line
                :background-color="pagoModificado(item) ? 'yellow lighten-4' : ''"
              ></v-text-field>
            </template>

            <template v-slot:item.pago_sabado="{ item }">
              <v-text-field
                v-model="item.pago_sabado"
                type="number"
                min="0"
                prefix="$"
                placeholder="Sin pago"
                dense
                hide-details
                single-line
                :background-color="pagoModificado(item) ? 'yellow lighten-4' : ''"
              ></v-text-field>
            </template>

            <template v-slot:item.vigente_desde="{ item }">
              <span class="text-caption">{{ item.vigente_desde || 'Sin tarifa' }}</span>
            </template>
          </v-data-table>
          <div class="caption grey--text mt-2">
            Los cambios aplican desde la fecha "Vigente desde"; las semanas anteriores conservan el pago que tenían.
            Deja el sábado vacío si la sucursal no tiene pago de sábado.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <Alerta v-if="respuestaAlerta" :parametros="parametros"/>
    <carga  v-if="cargar"/>
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'

  import Alerta         from '@/components/alertas/Alerta.vue'
  import carga          from '@/components/alertas/carga.vue'

  import validarErrores from '@/mixins/validarErrores'
  import funcionesExcel from '@/mixins/funcionesExcel'

  var moment = require('moment')

  /** Semana de nómina sábado → viernes; offset = días desde el sábado. */
  const DIAS = [
    { nombre: 'Sábado',    offset: 0 },
    { nombre: 'Lunes',     offset: 2 },
    { nombre: 'Martes',    offset: 3 },
    { nombre: 'Miércoles', offset: 4 },
    { nombre: 'Jueves',    offset: 5 },
    { nombre: 'Viernes',   offset: 6 },
  ]
  // Igual que ciclos.getSemanaActual (api-rh) y RolClases: 4 semanas operativas; en ciclos
  // más largos cuentan las 2 primeras y las 2 últimas, las de en medio son vacaciones.
  const SEMANAS_OPERATIVAS = 4

  export default {
    components: {
      Alerta,
      carga,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
      ciclos: [],
      ciclo: null,
      escuela: 1,
      semana: null,
      search: '',

      planteles: [],
      asignaciones: [],
      trabajadores: [],

      // Solo se aplica la respuesta de la petición más reciente.
      peticionRol: 0,
      peticionResumen: 0,

      fecha_hoy: moment().format('YYYY-MM-DD'),

      dialogAsignar: {
        estatus: false,
        id_plantel: null,
        plantel: '',
        fecha: null,
        diaTexto: '',
        asignacion: null,
        id_trabajador: null,
      },

      dialogConfirmar: {
        estatus: false,
        nombre: '',
        diaTexto: '',
        otras: [],
      },

      dialogAsistencia: {
        estatus: false,
        id: null,
        nombre: '',
        plantel: '',
        diaTexto: '',
        asistencia: 0,
        comentario: '',
      },

      dialogResumen: {
        estatus: false,
        modo: 'semana',
        asignaciones: [],
        id_trabajador: null,
        completo: false,
      },

      headersResumen: [
        { text: 'Intendente', value: 'intendente', sortable: false },
        { text: 'Escuela', value: 'escuela', sortable: false },
        { text: 'Sucursal', value: 'plantel', sortable: false },
        { text: 'L-V asignados', value: 'lvAsignados', align: 'center', sortable: false },
        { text: 'L-V con huella', value: 'lvHuella', align: 'center', sortable: false },
        { text: 'Sábados asignados', value: 'sabAsignados', align: 'center', sortable: false },
        { text: 'Sábados con huella', value: 'sabHuella', align: 'center', sortable: false },
        { text: 'Sin checada', value: 'sinChecada', align: 'center', sortable: false },
        { text: 'Total a pagar', value: 'total', align: 'end', sortable: false },
      ],

      dialogPagos: {
        estatus: false,
        escuela: 3,
        search: '',
        vigente_desde: moment().format('YYYY-MM-DD'),
        tarifas: [],
        originales: {},
      },

      headersPagos: [
        { text: 'Escuela',         value: 'escuela',           width: 90 },
        { text: 'Sucursal',        value: 'plantel' },
        { text: 'Lunes a viernes', value: 'pago_entre_semana', sortable: false, width: 160 },
        { text: 'Sábado',          value: 'pago_sabado',       sortable: false, width: 160 },
        { text: 'Vigente desde',   value: 'vigente_desde',     width: 130 },
      ],
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP']),

      /** Jefe de recursos humanos (68), Jefe de TI (11) y Desarrollador (12): únicos que ven y editan tarifas. */
      puedeEditarTarifas () {
        const u = this.getdatosUsuarioERPERP || {}
        const puesto = u.idpuesto != null && u.idpuesto !== '' ? u.idpuesto : u.id_puesto
        return [68, 11, 12].includes(Number(puesto))
      },

      rangoResumen () {
        if (this.dialogResumen.modo === 'ciclo') {
          if (!this.semanas.length) return null
          const inicio = this.semanas[0].inicio
          const fin    = this.semanas[this.semanas.length - 1].fin
          return { inicio, fin, texto: `Ciclo completo (${moment(inicio).format('DD/MM')} al ${moment(fin).format('DD/MM')})` }
        }
        if (!this.semanaSeleccionada) return null
        return {
          inicio: this.semanaSeleccionada.inicio,
          fin: this.semanaSeleccionada.fin,
          texto: this.semanaSeleccionada.texto,
        }
      },

      resumenIntendentes () {
        const vistos = {}
        this.dialogResumen.asignaciones.forEach((a) => {
          if (!vistos[a.id_trabajador]) {
            vistos[a.id_trabajador] = { id_trabajador: a.id_trabajador, nombre: a.nombre_completo || `Trabajador ${a.id_trabajador}` }
          }
        })
        return Object.values(vistos).sort((a, b) => a.nombre.localeCompare(b.nombre))
      },

      /** Un grupo por intendente: filas por sucursal + subtotal. */
      resumenGrupos () {
        const texto = String(this.search || '').trim().toUpperCase()
        const plantelesPorId = {}
        this.planteles.forEach((p) => { plantelesPorId[p.id_plantel] = p })

        const nuevoAcumulado = () => ({
          lvAsignados: 0, lvHuella: 0, sabAsignados: 0, sabHuella: 0, sinChecada: 0, total: 0,
        })
        // Se paga el día con huella en cualquier sucursal (la marca manual de asistencia no cuenta), con la
        // tarifa de la sucursal asignada; el backend ya manda ese monto en a.pago.
        const sumar = (acc, a) => {
          const sabado = moment(a.fecha).isoWeekday() === 6
          if (sabado) acc.sabAsignados++
          else acc.lvAsignados++
          if (a.huella) {
            if (sabado) acc.sabHuella++
            else acc.lvHuella++
            acc.total += Number(a.pago || 0)
          } else if (a.fecha <= this.fecha_hoy) {
            acc.sinChecada++
          }
        }

        const porIntendente = {}
        this.dialogResumen.asignaciones.forEach((a) => {
          if (this.dialogResumen.id_trabajador && a.id_trabajador != this.dialogResumen.id_trabajador) return
          const plantel = plantelesPorId[a.id_plantel]
          if (!plantel) return
          if (!this.perteneceEscuela(plantel, this.escuela)) return
          const nombre = a.nombre_completo || `Trabajador ${a.id_trabajador}`
          if (texto && !nombre.toUpperCase().includes(texto) && !String(plantel.plantel).toUpperCase().includes(texto)) return

          if (!porIntendente[a.id_trabajador]) {
            porIntendente[a.id_trabajador] = { nombre, sucursales: {}, acumulado: nuevoAcumulado() }
          }
          const grupo = porIntendente[a.id_trabajador]
          if (!grupo.sucursales[a.id_plantel]) {
            grupo.sucursales[a.id_plantel] = { plantel, acumulado: nuevoAcumulado() }
          }
          sumar(grupo.sucursales[a.id_plantel].acumulado, a)
          sumar(grupo.acumulado, a)
        })

        return Object.keys(porIntendente)
          .map((id) => ({ id, ...porIntendente[id] }))
          .sort((a, b) => a.nombre.localeCompare(b.nombre))
          .map((grupo) => {
            const filas = Object.values(grupo.sucursales)
              .sort((a, b) => a.plantel.plantel.localeCompare(b.plantel.plantel))
              .map((s) => ({
                key: `${grupo.id}-${s.plantel.id_plantel}`,
                tipo: 'detalle',
                intendente: grupo.nombre,
                escuela: s.plantel.escuela,
                plantel: s.plantel.plantel,
                ...s.acumulado,
              }))
            filas.push({ key: `${grupo.id}-total`, tipo: 'subtotal', intendente: `TOTAL ${grupo.nombre}`, plantel: '', ...grupo.acumulado })
            return { acumulado: grupo.acumulado, filas }
          })
      },

      /** Total de todos los intendentes filtrados, no solo los de la página. */
      resumenTotalGeneral () {
        if (!this.resumenGrupos.length) return null
        const general = {}
        this.resumenGrupos.forEach((grupo) => {
          Object.keys(grupo.acumulado).forEach((k) => { general[k] = (general[k] || 0) + grupo.acumulado[k] })
        })
        return { key: 'total-general', tipo: 'total', intendente: 'TOTAL GENERAL', plantel: '', ...general }
      },

      resumenFilas () {
        const filas = []
        this.resumenGrupos.forEach((grupo) => { filas.push(...grupo.filas) })
        if (this.resumenTotalGeneral) filas.push(this.resumenTotalGeneral)
        return filas
      },

      resumenFilasTabla () {
        return this.resumenFilas.filter((fila) => fila.tipo !== 'total')
      },

      pagosFiltrados () {
        const texto = String(this.dialogPagos.search || '').trim().toUpperCase()
        return this.dialogPagos.tarifas.filter((t) =>
          this.perteneceEscuela(t, this.dialogPagos.escuela) &&
          (!texto || String(t.plantel).toUpperCase().includes(texto))
        )
      },

      pagosModificados () {
        return this.dialogPagos.tarifas.filter((t) => this.pagoModificado(t))
      },

      /**
       * Semanas operativas del ciclo, de sábado a viernes: cada una inicia el sábado anterior
       * al lunes de su semana de ciclo (ciclo 09_26: semana 1 = sáb 12/09 al vie 18/09).
       */
      semanas () {
        if (!this.ciclo) return []
        const inicio = moment(String(this.ciclo.fecha_inicio_ciclo).substr(0, 10))
        const fin    = moment(String(this.ciclo.fecha_fin_ciclo).substr(0, 10))
        const lunes1 = inicio.isoWeekday() === 7
          ? inicio.clone().add(1, 'day')
          : inicio.clone().subtract(inicio.isoWeekday() - 1, 'days')

        const totalSemanas = Math.floor(fin.diff(lunes1, 'days') / 7) + 1
        if (totalSemanas < 1) return []

        const calendario = []
        if (totalSemanas <= SEMANAS_OPERATIVAS) {
          for (let i = 1; i <= totalSemanas; i++) calendario.push(i)
        } else {
          calendario.push(1, 2, totalSemanas - 1, totalSemanas)
        }

        return calendario.map((semanaCalendario, i) => {
          const lunes   = lunes1.clone().add((semanaCalendario - 1) * 7, 'days')
          const sabado  = lunes.clone().subtract(2, 'days')
          const viernes = lunes.clone().add(4, 'days')
          return {
            value: i + 1,
            inicio: sabado.format('YYYY-MM-DD'),
            fin: viernes.format('YYYY-MM-DD'),
            texto: `Semana ${i + 1} (${sabado.format('DD/MM')} al ${viernes.format('DD/MM')})`,
          }
        })
      },

      semanaSeleccionada () {
        return this.semanas.find((s) => s.value === this.semana) || null
      },

      diasSemana () {
        if (!this.semanaSeleccionada) return []
        const sabado = moment(this.semanaSeleccionada.inicio)
        return DIAS.map((dia, i) => {
          const fecha = sabado.clone().add(dia.offset, 'days')
          return {
            key: `d${i + 1}`,
            slot: `item.d${i + 1}`,
            nombre: dia.nombre,
            fecha: fecha.format('YYYY-MM-DD'),
            texto: `${dia.nombre} ${fecha.format('DD/MM')}`,
          }
        })
      },

      headers () {
        return [
          { text: 'Escuela',  value: 'escuela', width: 90 },
          { text: 'Sucursal', value: 'plantel', width: 160 },
        ].concat(this.diasSemana.map((dia) => ({ text: dia.texto, value: dia.key, sortable: false, width: 150 })))
      },

      filas () {
        return this.planteles
          .filter((p) => this.perteneceEscuela(p, this.escuela))
          .map((p) => {
            const fila = { id_plantel: p.id_plantel, plantel: p.plantel, escuela: p.escuela }
            this.diasSemana.forEach((dia) => {
              fila[dia.key] = this.asignaciones.find((a) => a.id_plantel == p.id_plantel && a.fecha === dia.fecha) || null
            })
            return fila
          })
      },

      filasFiltradas () {
        const texto = String(this.search || '').trim().toUpperCase()
        if (!texto) return this.filas
        return this.filas.filter((fila) => {
          if (String(fila.plantel).toUpperCase().includes(texto)) return true
          return this.diasSemana.some((dia) =>
            fila[dia.key] && String(fila[dia.key].nombre_completo || '').toUpperCase().includes(texto)
          )
        })
      },

      totales () {
        let asignados = 0
        let sinChecada = 0
        this.filasFiltradas.forEach((fila) => {
          this.diasSemana.forEach((dia) => {
            if (!fila[dia.key]) return
            asignados++
            if (this.sinChecada(fila[dia.key], dia.fecha)) sinChecada++
          })
        })
        return { asignados, sinChecada, dias: this.filasFiltradas.length * this.diasSemana.length }
      },

      trabajadoresDialog () {
        const otras = {}
        this.otrasAsignacionesDia(this.dialogAsignar.fecha, this.dialogAsignar.id_plantel).forEach((a) => {
          if (!otras[a.id_trabajador]) otras[a.id_trabajador] = []
          otras[a.id_trabajador].push(this.nombrePlantel(a.id_plantel))
        })

        return this.trabajadores.map((t) => ({
          ...t,
          texto: otras[t.id_trabajador]
            ? `${t.nombre_completo} (también en ${otras[t.id_trabajador].join(', ')})`
            : t.nombre_completo,
        }))
      },
    },

    watch: {
      ciclo () {
        this.asignaciones = []
        if (!this.ciclo) {
          this.semana = null
          return
        }
        // Fuera de las semanas operativas (domingo o vacaciones) queda la última que ya inició.
        const actual = this.semanas.find((s) => this.fecha_hoy >= s.inicio && this.fecha_hoy <= s.fin) ||
          this.semanas.filter((s) => s.inicio <= this.fecha_hoy).pop()
        const semana = actual ? actual.value : 1
        if (this.semana === semana) {
          this.consultar()
        } else {
          this.semana = semana
        }
      },

      semana () {
        if (this.semana) this.consultar()
      },

      'dialogResumen.modo' () {
        if (this.dialogResumen.estatus) this.cargarResumen()
      },

    },

    async created () {
      await this.getCiclos()
      await this.getTrabajadores()
    },

    methods: {
      mensajeError (error) {
        if (error && error.response && error.response.data && error.response.data.message) {
          return error.response.data.message
        }
        return 'Error en la conexión con el servidor'
      },

      getCiclos () {
        this.cargar = true
        this.ciclos = []
        return this.$http.get('roles.ciclos.all').then((response) => {
          this.ciclos = response.data.filter((c) => c.ciclo.search('FE') === -1 && c.ciclo.search('CICLO') !== -1)
          // Las semanas van de sábado a viernes: el ciclo arranca 2 días antes de su lunes de inicio.
          const desplazado = (fecha) => moment(String(fecha).substr(0, 10)).subtract(2, 'days').format('YYYY-MM-DD')
          this.ciclo = this.ciclos.find((c) =>
            this.fecha_hoy >= desplazado(c.fecha_inicio_ciclo) &&
            this.fecha_hoy <= desplazado(c.fecha_fin_ciclo)
          ) || this.ciclos.find((c) =>
            this.fecha_hoy >= String(c.fecha_inicio_ciclo).substr(0, 10) &&
            this.fecha_hoy <= String(c.fecha_fin_ciclo).substr(0, 10)
          ) || null
        }).catch((error) => {
          this.validarError(this.mensajeError(error))
        }).finally(() => { this.cargar = false })
      },

      getTrabajadores () {
        return this.$http.get('rol.limpieza.trabajadores').then((response) => {
          this.trabajadores = response.data
        }).catch((error) => {
          this.validarError(this.mensajeError(error))
        })
      },

      consultar () {
        if (!this.semanaSeleccionada) {
          return this.validarErrorDirecto('Selecciona un ciclo y una semana por favor')
        }

        const peticion = ++this.peticionRol
        this.cargar = true
        const payload = {
          fecha_inicio: this.semanaSeleccionada.inicio,
          fecha_fin: this.semanaSeleccionada.fin,
        }
        return this.$http.post('rol.limpieza.list', payload).then((response) => {
          if (peticion !== this.peticionRol) return
          this.planteles    = response.data.planteles
          this.asignaciones = response.data.asignaciones
        }).catch((error) => {
          if (peticion !== this.peticionRol) return
          this.validarError(this.mensajeError(error))
        }).finally(() => {
          if (peticion === this.peticionRol) this.cargar = false
        })
      },

      /** Con que haya checado ese día en cualquier sucursal (o manual), el backend manda huella. */
      sinChecada (asignacion, fecha) {
        return !!asignacion && fecha <= this.fecha_hoy && !asignacion.huella
      },

      /** Los corporativos (escuela 0) salen en INBI, FAST y AMBAS. */
      perteneceEscuela (plantel, escuela) {
        return escuela === 3 || plantel.escuela == 0 || plantel.escuela == escuela
      },

      textoEscuela (escuela) {
        if (escuela == 1) return 'INBI'
        if (escuela == 2) return 'FAST'
        return 'CORPO'
      },

      nombrePlantel (idPlantel) {
        const plantel = this.planteles.find((p) => p.id_plantel == idPlantel)
        return plantel ? plantel.plantel : 'otra sucursal'
      },

      otrasAsignacionesDia (fecha, idPlantel, idTrabajador = null) {
        return this.asignaciones.filter((a) =>
          a.fecha === fecha &&
          a.id_plantel != idPlantel &&
          (idTrabajador === null || a.id_trabajador == idTrabajador)
        )
      },

      colorAsistencia (asistencia) {
        if (asistencia == 1) return 'green'
        if (asistencia == 2) return 'red'
        return 'grey'
      },

      textoAsistencia (asistencia) {
        if (asistencia == 1) return 'Asistió'
        if (asistencia == 2) return 'No asistió'
        return 'Pendiente'
      },

      abrirAsignar (fila, dia) {
        const asignacion = fila[dia.key]
        this.dialogAsignar = {
          estatus: true,
          id_plantel: fila.id_plantel,
          plantel: fila.plantel,
          fecha: dia.fecha,
          diaTexto: dia.texto,
          asignacion,
          id_trabajador: asignacion ? asignacion.id_trabajador : null,
        }
      },

      guardarAsignacion (confirmar) {
        if (!this.dialogAsignar.id_trabajador) {
          return this.validarErrorDirecto('Selecciona un intendente')
        }

        if (!confirmar) {
          const otras = this.otrasAsignacionesDia(this.dialogAsignar.fecha, this.dialogAsignar.id_plantel, this.dialogAsignar.id_trabajador)
          if (otras.length) {
            const trabajador = this.trabajadores.find((t) => t.id_trabajador == this.dialogAsignar.id_trabajador)
            return this.abrirConfirmar(trabajador ? trabajador.nombre_completo : otras[0].nombre_completo, otras)
          }
        }

        this.cargar = true
        const payload = {
          fecha: this.dialogAsignar.fecha,
          id_plantel: this.dialogAsignar.id_plantel,
          id_trabajador: this.dialogAsignar.id_trabajador,
          confirmar: !!confirmar,
        }
        this.$http.post('rol.limpieza.asignar', payload).then((response) => {
          // Otro usuario la asignó en otra sucursal después de cargar la vista.
          if (response.data && response.data.requiere_confirmacion) {
            return this.abrirConfirmar(response.data.nombre_completo, response.data.asignaciones)
          }
          this.dialogConfirmar.estatus = false
          this.dialogAsignar.estatus = false
          return this.consultar()
        }).catch((error) => {
          this.validarError(this.mensajeError(error))
        }).finally(() => { this.cargar = false })
      },

      abrirConfirmar (nombre, otras) {
        this.dialogConfirmar = {
          estatus: true,
          nombre,
          diaTexto: this.dialogAsignar.diaTexto,
          otras: otras.map((o) => {
            const local = this.asignaciones.find((a) => a.id == o.id)
            return {
              id: o.id,
              plantel: o.plantel || this.nombrePlantel(o.id_plantel),
              checo: local && local.checada ? local.checada.primera : null,
            }
          }),
        }
      },

      confirmarAsignacion () {
        this.guardarAsignacion(true)
      },

      eliminarAsignacion () {
        if (!this.dialogAsignar.asignacion) return

        this.cargar = true
        this.$http.post('rol.limpieza.eliminar', { id: this.dialogAsignar.asignacion.id }).then(() => {
          this.dialogAsignar.estatus = false
          return this.consultar()
        }).catch((error) => {
          this.validarError(this.mensajeError(error))
        }).finally(() => { this.cargar = false })
      },

      abrirAsistencia (fila, dia) {
        const asignacion = fila[dia.key]
        this.dialogAsistencia = {
          estatus: true,
          id: asignacion.id,
          nombre: asignacion.nombre_completo,
          plantel: fila.plantel,
          diaTexto: dia.texto,
          asistencia: Number(asignacion.asistencia) || 0,
          comentario: asignacion.comentario_asistencia || '',
        }
      },

      guardarAsistencia () {
        this.cargar = true
        const payload = {
          id: this.dialogAsistencia.id,
          asistencia: this.dialogAsistencia.asistencia,
          comentario: this.dialogAsistencia.comentario,
        }
        this.$http.post('rol.limpieza.asistencia', payload).then(() => {
          this.dialogAsistencia.estatus = false
          return this.consultar()
        }).catch((error) => {
          this.validarError(this.mensajeError(error))
        }).finally(() => { this.cargar = false })
      },

      formatoMoneda (valor) {
        return `$${Number(valor || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
      },

      claseFilaResumen (fila) {
        if (!fila || fila.tipo === 'detalle') return ''
        return 'fila-subtotal font-weight-bold'
      },

      abrirResumen () {
        this.dialogResumen.completo = false
        this.dialogResumen.estatus = true
        this.cargarResumen()
      },

      abrirTotal () {
        this.dialogResumen.completo = true
        this.dialogResumen.estatus = true
        this.cargarResumen()
      },

      cargarResumen () {
        if (!this.rangoResumen) {
          return this.validarErrorDirecto('Selecciona un ciclo y una semana por favor')
        }

        const peticion = ++this.peticionResumen
        this.cargar = true
        this.dialogResumen.asignaciones = []
        const payload = { fecha_inicio: this.rangoResumen.inicio, fecha_fin: this.rangoResumen.fin }
        return this.$http.post('rol.limpieza.list', payload).then((response) => {
          if (peticion !== this.peticionResumen) return
          // En ciclos largos el rango incluye semanas de vacaciones que no se muestran.
          const enSemanaOperativa = (fecha) => this.semanas.some((s) => fecha >= s.inicio && fecha <= s.fin)
          this.dialogResumen.asignaciones = response.data.asignaciones.filter((a) => enSemanaOperativa(a.fecha))
        }).catch((error) => {
          if (peticion !== this.peticionResumen) return
          this.validarError(this.mensajeError(error))
        }).finally(() => {
          if (peticion === this.peticionResumen) this.cargar = false
        })
      },

      exportarResumen () {
        const dataExport = this.resumenFilas.map((fila) => ({
          Intendente: fila.intendente,
          Escuela: fila.tipo === 'detalle' ? this.textoEscuela(fila.escuela) : '',
          Sucursal: fila.plantel,
          'L-V asignados': fila.lvAsignados,
          'L-V con huella': fila.lvHuella,
          'Sábados asignados': fila.sabAsignados,
          'Sábados con huella': fila.sabHuella,
          'Sin checada': fila.sinChecada,
          'Total a pagar': fila.total,
        }))

        const ciclo = this.ciclo ? this.ciclo.ciclo.replace(/\s+/g, '_') : 'ciclo'
        const periodo = this.dialogResumen.modo === 'ciclo' ? 'Ciclo' : `Semana_${this.semana}`
        this.exportarExcelDirecto(dataExport, `Resumen_Limpieza_${ciclo}_${periodo}`)
      },

      normalizarPago (valor) {
        if (valor === null || valor === undefined || String(valor).trim() === '') return null
        return Number(valor)
      },

      pagoModificado (tarifa) {
        const original = this.dialogPagos.originales[tarifa.id_plantel] || {}
        return this.normalizarPago(tarifa.pago_entre_semana) !== this.normalizarPago(original.pago_entre_semana) ||
          this.normalizarPago(tarifa.pago_sabado) !== this.normalizarPago(original.pago_sabado)
      },

      abrirPagos () {
        this.dialogPagos.estatus = true
        this.dialogPagos.escuela = this.escuela
        this.dialogPagos.search = ''
        this.dialogPagos.vigente_desde = moment().format('YYYY-MM-DD')
        this.cargarPagos()
      },

      cargarPagos () {
        this.cargar = true
        return this.$http.get('rol.limpieza.tarifas').then((response) => {
          const originales = {}
          response.data.forEach((t) => { originales[t.id_plantel] = { ...t } })
          this.dialogPagos.originales = originales
          this.dialogPagos.tarifas = response.data.map((t) => ({
            ...t,
            pago_entre_semana: t.pago_entre_semana === null ? '' : t.pago_entre_semana,
            pago_sabado: t.pago_sabado === null ? '' : t.pago_sabado,
          }))
        }).catch((error) => {
          this.validarError(this.mensajeError(error))
        }).finally(() => { this.cargar = false })
      },

      guardarPagos () {
        if (!this.dialogPagos.vigente_desde) {
          return this.validarErrorDirecto('Selecciona la fecha "Vigente desde"')
        }
        const invalida = this.pagosModificados.find((t) =>
          [t.pago_entre_semana, t.pago_sabado].some((v) => {
            const n = this.normalizarPago(v)
            return n !== null && (!Number.isFinite(n) || n < 0)
          })
        )
        if (invalida) {
          return this.validarErrorDirecto(`Revisa los pagos de ${invalida.plantel}: deben ser números mayores o iguales a 0`)
        }

        this.cargar = true
        const payload = {
          vigente_desde: this.dialogPagos.vigente_desde,
          tarifas: this.pagosModificados.map((t) => ({
            id_plantel: t.id_plantel,
            pago_entre_semana: this.normalizarPago(t.pago_entre_semana),
            pago_sabado: this.normalizarPago(t.pago_sabado),
          })),
        }
        this.$http.post('rol.limpieza.tarifas.guardar', payload).then((response) => {
          this.validarSuccess(response.data.message)
          this.cargarPagos()
          this.consultar()
        }).catch((error) => {
          this.validarError(this.mensajeError(error))
        }).finally(() => { this.cargar = false })
      },

      exportarExcel () {
        const dataExport = this.filasFiltradas.map((fila) => {
          const row = {
            Escuela: this.textoEscuela(fila.escuela),
            Sucursal: fila.plantel,
          }
          this.diasSemana.forEach((dia) => {
            const a = fila[dia.key]
            if (!a) {
              row[dia.texto] = ''
              return
            }
            let checada = 'Sin checada'
            if (a.checada) checada = `Checada ${a.checada.primera}-${a.checada.ultima}`
            else if (a.huella && a.huella.manual) checada = `Checada manual ${a.huella.primera}-${a.huella.ultima}`
            row[dia.texto] = `${a.nombre_completo} | ${this.textoAsistencia(a.asistencia)} | ${checada}`
          })
          return row
        })

        const ciclo = this.ciclo ? this.ciclo.ciclo.replace(/\s+/g, '_') : 'ciclo'
        this.exportarExcelDirecto(dataExport, `Rol_Limpieza_${ciclo}_Semana_${this.semana}`)
      },
    },
  }
</script>

<style scoped>
  .celda-sin-checada {
    background-color: yellow !important;
  }

  .subrayado {
    text-decoration: underline;
  }

  .fila-subtotal {
    background-color: #eeeeee;
  }
</style>
